//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import codeLogin from "./loginBox/codeLogin";
import pwdLogin from "./loginBox/pwdLogin";

import mainMenuTab from "@/components/mainMenuTab";
import divline from "@/components/ui/divline";

import weixin from "@/assets/js/weixin.js";
export default {
  components: { mainMenuTab, divline, codeLogin, pwdLogin },
  data() {
    return {
      type: "wx",
    };
  },
  methods: {
    // 微信登录
    wxAuth() {
      const opts = {
        refre: common.storage("referid") || "",
        redirect: encodeURIComponent(location.origin + "/loginWx"),
      };
      const authLink = api.loginWx + "?" + common.urlMerge(opts);

      location.href = authLink;
    },

    // 如果已经登录
    isLogin() {
      const userInfo = common.storageJson("userInfo") || {};

      if (userInfo.user_id) {
        this.$router.push("/");
      }
    },
  },
  mounted() {

      //https://api.map.baidu.com/location/ip?ak=S6X0BXERLCz7MGwtACSs0LQPTXMWYEGx&coor=bd09ll
      //http://api.map.baidu.com/reverse_geocoding/v3/?ak=S6X0BXERLCz7MGwtACSs0LQPTXMWYEGx&output=json&coordtype=wgs84ll&location=31.225696563611,121.49884033194

      weixin.queryWechatConfigure()
        .then(res=>weixin.initWechat(res))
        .then(res=>weixin.getUserLocation(res))
        .then(res=>{
            //console.log(res);

        });
  },
  beforeMount() {
    this.isLogin();
  },
};



// WEBPACK FOOTER //
// ./src/views/login/debug.vue